export default __webpack_public_path__ + "static/Collins_Aerospace-6266be812ad6bb57539a75fef19a566a.png";